var React = require('react');

function OHREP (props) {
    return React.createElement("svg",props,[React.createElement("filter",{"id":"inside","x":"-50%","y":"-50%","height":"200%","width":"200%","key":0},[React.createElement("feGaussianBlur",{"stdDeviation":"32","result":"offset-blur","key":0}),React.createElement("feComposite",{"operator":"out","in":"SourceGraphic","in2":"offset-blur","result":"inverse","key":1}),React.createElement("feFlood",{"floodColor":"#1c1c19","result":"color","key":2}),React.createElement("feComposite",{"operator":"in","in":"color","in2":"inverse","result":"shadow","key":3}),React.createElement("feComposite",{"operator":"over","in":"shadow","in2":"SourceGraphic","key":4})]),React.createElement("path",{"d":"m0 0h1024v1024h-1024z","fill":"#1c1c19","key":1}),React.createElement("circle",{"cx":"697.5","cy":"697.5","r":"262.5","fill":"#fffdfa","filter":"url(#inside)","key":2})]);
}

OHREP.defaultProps = {"viewBox":"0 0 1024 1024","version":"1.1"};

module.exports = OHREP;

OHREP.default = OHREP;
